import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageToJpgConfig } from '@/data/landingConfig/landingImageToJpgConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageToJpg } from './schemaObject';

interface Props {}
const ImageToJpgConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageToJpg} />
			<LandingTemplate
				data={landingImageToJpgConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default ImageToJpgConverter;
